<section class="container-card">
  <a
    [routerLink]="
      '/' +
      language +
      '/invertir/propiedad/' +
      cardData.publicationSummary.reference
    "
    (click)="removeOldSearch()"
    class="linkRef"
  >
    <div class="card-img-container">
      <img
        *ngIf="!showError"
        class="d-block w-100 card-img"
        [src]="images[0]"
        alt="First slide"
        loading="lazy"
        (load)="onImageLoad($event)"
        (error)="onImageLoadError($event)"
      />
      <div *ngIf="showError" class="no-disponible">
        <img
          src="{{ picturesServer }}img/isologo-inviertis-white.png"
          width="100%"
          alt="logo de inviertis en blanco"
          loading="lazy"
        />
        <p translate>components.card.Imagen no disponible</p>
      </div>
      <article class="tags">
        <div class="verified" *ngIf="cardData.publicationInspection?.inspection_date">
          <span class="verified-text">✓ 
            <span class="verified-text" translate>components.homePage.verified</span>
          </span>
        </div>
        <!--<div class="tag black-month-tag" *ngIf="cardData.publicationSummary?.is_important_property">
          <span class="tag-text">Black <span style="color:red">Month</span></span>
        </div>-->
        <div class="tag" *ngIf="cardData.publicationSummary?.is_important_property">
            <span class="tag-text" translate>components.card.Destacado</span>
        </div>
      </article>
    </div>
    <div class="card-text-container">
      <div class="card-text-amounts">
        <div class="card-text-profitability">
          <img src="../../../../assets/icons/icono-rentabilidad.svg" alt="ícono rentabilidad" loading="lazy">
          <p class="percentage">
            {{
              cardData.publicationSummary?.gross_profitability / 100
                | percent : "1.0-2"
            }}
          </p>
        </div>
        <p class="amount">
          {{
            cardData.propertyPrice?.mount
              | currency : "EUR" : "" : "1.0-2" : "en-DE"
          }}€
        </p>
      </div>
      <p class="address">
        {{
          cardData.propertyHistories[0].property.address.location.description
        }}
        ({{
          cardData.propertyHistories[0].property.address.location.province
            .description
        }})
      </p>
    </div>
  </a>
  <div class="card-padding d-flex flex-column position-relative" *ngIf="false">
    <div *ngIf="isBrowser">
      <div *ngIf="!images.length" class="no-disponible">
        <img
          src="{{ picturesServer }}img/isologo-inviertis-white.png"
          width="100%"
          alt="logo de inviertis en blanco"
          loading="lazy"
        />
        <p translate>components.card.Imagen no disponible</p>
      </div>
      <div
        *ngIf="images.length"
        style="overflow: hidden"
        [id]="'carouselIndicators' + index"
        class="carousel slide"
        data-interval="false"
        data-ride="carousel"
        data-pause="hover"
        (mouseover)="loadImages()"
      >
        <div class="carousel-inner" style="height: 15rem">
          <div
            class="carousel-item"
            [ngClass]="{ active: j === 0 }"
            *ngFor="let image of images; index as j"
          >
            <div *ngIf="estado == 'Vendida'">
              <img
                class="d-block w-100 eye"
                src="{{ picturesServer }}img/marcaVendida.png"
                alt="marca para propiedad vendida"
                loading="lazy"
              />
              <img
                class="d-block w-100"
                [src]="image"
                alt="First slide"
                loading="lazy"
              />
            </div>

            <div *ngIf="estado == 'Reservada'">
              <img
                class="d-block w-100 eye"
                src="{{ picturesServer }}img/marcaReservada.png"
                alt="marca para propiedad reservada"
                loading="lazy"
              />
              <img
                class="d-block w-100"
                [src]="image"
                alt="First slide"
                loading="lazy"
              />
            </div>
            <div *ngIf="estado == 'Retirada'">
              <img
                class="d-block w-100 eye"
                src="{{ picturesServer }}img/marcaNoDisponible.png"
                alt="marca para propiedad no disponible"
                loading="lazy"
              />
              <img
                class="d-block w-100"
                [src]="image"
                alt="First slide"
                loading="lazy"
              />
            </div>

            <div *ngIf="estado == 'Publicada'; else elseBlock">
              <img
                class="d-block w-100"
                [src]="image"
                alt="First slide"
                loading="lazy"
              />
            </div>

            <ng-template #elseBlock>
              <img
                class="d-block w-100"
                [src]="image"
                alt="First slide"
                loading="lazy"
              />
            </ng-template>
          </div>
        </div>

        <a
          class="carousel-control-prev"
          [ngClass]="{ 'arrow-hide': arrowhide }"
          [href]="'#carouselIndicators' + index"
          role="button"
          data-slide="prev"
        >
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a
          class="carousel-control-next"
          [ngClass]="{ 'arrow-hide': arrowhide }"
          [href]="'#carouselIndicators' + index"
          role="button"
          data-slide="next"
        >
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
    <a
      [routerLink]="
        '/' +
        language +
        '/invertir/propiedad/' +
        cardData.publicationSummary.reference
      "
      (click)="removeOldSearch()"
      class="linkRef"
    >
      <div
        class="container-body"
        (mouseenter)="mouseEnter()"
        (mouseleave)="mouseLeave()"
      >
        <!-- Overlay -->
        <div class="overlay">
          <div class="card--mask" style="margin-left: 10px">
            <!--Solo para edificios-->
            <div
              *ngIf="
                cardData.propertyHistories[0].property.propertyType
                  .description == 'Edificio';
                else OtrasPropiedades
              "
            >
              <!-- Numero de unidades -->
              <span class="mask--span">
                <b translate>components.card.Numero de unidades:</b>
                {{
                  cardData.publicationSummary?.building_or_portfolio?.qty_units
                    ? cardData.publicationSummary?.building_or_portfolio
                        ?.qty_units
                    : 0
                }}
              </span>
            </div>

            <ng-template #OtrasPropiedades>
              <!-- Habitacion -->
              <span
                *ngIf="cardData.publicationSummary?.qty_room"
                class="mask--span"
              >
                <img
                  src="{{ picturesServer }}img/habitacion.svg"
                  class="mask--icon mr-2"
                  alt="ícono para habitación"
                  loading="lazy"
                />
                {{ cardData.publicationSummary?.qty_room }}
                <span translate>
                  components.card.{{
                    cardData.publicationSummary?.qty_room === 1
                      ? "Habitacion"
                      : "Habitaciones"
                  }}
                </span>
              </span>
              <!-- Baños -->
              <span class="mask--span">
                <img
                  src="{{ picturesServer }}img/baños.svg"
                  class="mask--icon mr-2"
                  alt="ícono para baños"
                  loading="lazy"
                />
                {{ cardData.publicationSummary?.qty_toilet }}
                <span translate>
                  components.card.{{
                    cardData.publicationSummary?.qty_toilet === 1
                      ? "Baño"
                      : "Baños"
                  }}
                </span>
              </span>
            </ng-template>

            <!-- M2 -->
            <span class="mask--span">
              <img
                src="{{ picturesServer }}img/superficie.svg"
                class="mask--icon mr-2"
                alt="ícono para superficie total"
                loading="lazy"
              />
              {{ cardData.publicationSummary?.total_meters }} m²
            </span>

            <!--Fecha de fin del contrato-->
            <span
              class="mask--span"
              *ngIf="
                cardData.publicationRental.length > 0 &&
                cardData.publicationRental[0]?.ending_rent_contract
              "
            >
              <a class="mr-1" translate> components.card.Fin del contrato: </a
              ><b>{{
                cardData.publicationRental[0]?.ending_rent_contract
                  | date : "dd/MM/yyyy"
              }}</b>
            </span>
          </div>
        </div>
        <!--Cuerpo de la card -->
        <div
          class="card-body pb-0 pt-3 px-3 d-flex flex-column justify-content-between pb-2"
        >
          <h5 class="card-title">
            <span
              *ngIf="cardData.propertyPrice?.mount; else elseBlock"
              class="card-title-price d-flex justify-content-between"
            >
              <span class="card-title-price">
                {{
                  cardData.propertyPrice?.mount
                    | currency : "EUR" : "symbol" : "1.0-2" : "en-DE"
                }}
              </span>
              <span
                class="card-text destacado"
                *ngIf="cardData.publicationSummary?.is_important_property"
                translate
                >components.card.Destacado</span
              >
            </span>
            <ng-template #elseBlock
              ><span class="title-else" translate
                >components.card.Sin tasación actual</span
              >
            </ng-template>
          </h5>

          <div class="card-numbers">
            <p class="card-text-location" translate>
              {{
                cardData.propertyHistories[0].property.address.location
                  .description
              }}
              ({{
                cardData.propertyHistories[0].property.address.location.province
                  .description
              }})
            </p>
            <p class="card-text card-text-rent" translate>
              components.card.Rentabilidad:<span class="resaltado">{{
                cardData.publicationSummary?.gross_profitability / 100
                  | percent : "1.0-2"
              }}</span>
            </p>
            <div class="rentAndRef">
              <p class="card-text card-text-alq" translate>
                components.card.Alquiler actual:
                <span class="resaltado">{{
                  cardData.publicationSummary?.price_rental
                    ? (cardData.publicationSummary?.price_rental
                      | currency : "EUR" : "symbol" : "1.0-2" : "en-DE")
                    : "N/A"
                }}</span>
              </p>
              <span class="ref">
                <span class="mr-2">Ref:</span
                >{{ cardData.publicationSummary?.reference }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</section>
